const initialState = {
    filter:{
        initDate: null,
        endDate: null,
        nameLaboratory: null,
        regionalId: null
    },
    isFilter: false
};

const filterCollectiveServiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FILTER_COLLECTIVE_SERVICE':
            
            return {
                ...state,
                filter: action.filter,
                isFilter: action.isFilter
            }
    
        default:
            return state;
    }
}

export default filterCollectiveServiceReducer;